import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Table } from 'react-bootstrap';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';

import './claims-configuration.scss';
import TextInput from 'src/Components/GenericInputText/TextInput';
import Checkbox from '../../common/Checkbox';
import WarningComponent from '../WarningComponent';
import ToastMessage from '../../common/ToastMessage';
import { toast } from 'react-toastify';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';

const RenderTable = (props) => {
  return (
    <Table striped hover>
      <thead>
        <tr>
          <th className={props.onlyForMembers ? 'w-80' : ''}>JV Core Status</th>
          <th className={props.onlyForMembers ? 'text-center' : ''}>
            For Members/ Dependents
          </th>
          {!props.onlyForMembers && (
            <>
              <th>For Insurers</th>
              <th>For Employers</th>
              <th>For Brokers</th>
              <th>For Providers</th>
            </>
          )}
        </tr>
      </thead>
      <tbody>{props.children}</tbody>
    </Table>
  );
};

const ClaimsConfiguration = (props) => {
  const [editMode, setEditMode] = useState(false);
  const [loader, setLoader] = useState(false);
  const [claimsListData, setClaimsListData] = useState([]);
  const [claimsListDataOriginal, setClaimsListDataOriginal] = useState([]);
  const [valuesChanged, setValuesChanged] = useState(false);
  const [clickOnSaveNotificationShown, setClickOnSaveNotificationShown] =
    useState(false);
  useEffect(() => {
    setLoader(true);
    const getClaimLabels = async () => {
      return await axiosInstance.get(`${APIEndpoints.getAllClaimLabelsLIst()}`);
    };
    (async () => {
      try {
        const resourceData = await getClaimLabels();
        console.log('claims labels list >>>>>', resourceData);
        const claimStatusesList =
          resourceData?.data?.Response?.ClaimStatusLabels;

        setClaimsListData([...claimStatusesList]);
        setClaimsListDataOriginal([...claimStatusesList]);
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    })();
  }, []);

  const onValueChange = (value, index, key) => {
    const data = [...claimsListData];
    data[index][key] = value;
    if (key !== 'DisplayOnDashboard') {
      setClaimsListData(data);
    } else {
      if (value === true) {
        if (validateDisplayOnDashboard(data)) {
          setClaimsListData(data);
        } else {
          data[index][key] = false;
        }
      } else {
        setClaimsListData(data);
      }
    }
    setValuesChanged(true);
    if (!clickOnSaveNotificationShown) {
      toast.warning(
        <ToastMessage
          type="warning"
          subTitle={
            'Click on Save Button (scroll to the end of the page) to update your changes.'
          }
        />,
        { position: 'top-right', delay: 10000 },
      );
      setClickOnSaveNotificationShown(true);
    }
  };

  const validateDisplayOnDashboard = (data) => {
    const dataToValidate = data || [...claimsListData];
    if (
      dataToValidate.filter((d) => d.DisplayOnDashboard === true).length > 3
    ) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={'Only 3 options can be selected to display on dashboard'}
        />,
      );
      return false;
    } else {
      return true;
    }
  };

  const updateDataApiCallHandler = async () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    try {
      const updateNetworkResponce = await axiosInstance.put(
        `${APIEndpoints.updateStatusLabels()}`,
        { ClaimStatusLabels: claimsListData },
      );
      if (
        HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === updateNetworkResponce.status
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={'Labels updated successfully'}
          />,
          setEditMode(false),
          setValuesChanged(false),
        );
      }
    } catch (error) {
      console.log(error);
      if (error.toString().includes('409')) {
        toast.warning(
          <ToastMessage type="warning" subTitle={'Could not update labels.'} />,
        );
      } else {
        toast.error(
          <ToastMessage type="error" subTitle={'Label updation failed'} />,
        );
      }
    }
  };

  return (
    <div className="claims-configuration-page">
      <div className="parent-div">
        <div className="d-flex align-items-center">
          <h2>Claims Configuration</h2>
        </div>
        <div className="text-right my-2">
          <GenericButton
            onClick={() => setEditMode((prevState) => !prevState)}
            className="ml-1"
            disable={editMode}
            buttonDisabled={true}
          >
            Edit
          </GenericButton>
        </div>
      </div>
      <div>
        {editMode && (
          <div className="mb-3">
            <WarningComponent />
          </div>
        )}
        <Tabs
          defaultActiveKey={'label_configuration'}
          id={'claims-configuration-tabs'}
          transition={false}
        >
          <Tab eventKey={'label_configuration'} title="Label Configuration">
            <div>
              <p className="help-text">
                Configure Labels for each of JV Core Claim Status
              </p>
            </div>
            <div className="table-container">
              <RenderTable>
                {claimsListData.map((label, index) => {
                  return (
                    <tr key={label.InternalStatus}>
                      <td className="internal-status-cell">
                        {label.InternalStatus}
                      </td>
                      <td>
                        <TextInput
                          name={`${label.InternalStatus}[ExternalStatusMemberDependent]`}
                          inputProps={{
                            value: label.ExternalStatusMemberDependent,
                            disabled: !editMode,
                            onChange: (e) => {
                              console.log(e.target.value);
                              onValueChange(
                                e.target.value,
                                index,
                                'ExternalStatusMemberDependent',
                              );
                            },
                          }}
                        />
                      </td>
                      <td>
                        <TextInput
                          name={`${label.InternalStatus}[ExternalStatusInsurer]`}
                          inputProps={{
                            value: label.ExternalStatusInsurer,
                            disabled: !editMode,
                            onChange: (e) => {
                              console.log(e.target.value);
                              onValueChange(
                                e.target.value,
                                index,
                                'ExternalStatusInsurer',
                              );
                            },
                          }}
                        />
                      </td>
                      <td>
                        <TextInput
                          name={`${label.InternalStatus}[ExternalStatusClient]`}
                          inputProps={{
                            value: label.ExternalStatusClient,
                            disabled: !editMode,
                            onChange: (e) => {
                              console.log(e.target.value);
                              onValueChange(
                                e.target.value,
                                index,
                                'ExternalStatusClient',
                              );
                            },
                          }}
                        />
                      </td>
                      <td>
                        <TextInput
                          name={`${label.InternalStatus}[ExternalStatusBroker]`}
                          inputProps={{
                            value: label.ExternalStatusBroker,
                            disabled: !editMode,
                            onChange: (e) => {
                              console.log(e.target.value);
                              onValueChange(
                                e.target.value,
                                index,
                                'ExternalStatusBroker',
                              );
                            },
                          }}
                        />
                      </td>
                      <td>
                        <TextInput
                          name={`${label.InternalStatus}[ExternalStatusProvider]`}
                          inputProps={{
                            value: label.ExternalStatusProvider,
                            disabled: !editMode,
                            onChange: (e) => {
                              console.log(e.target.value);
                              onValueChange(
                                e.target.value,
                                index,
                                'ExternalStatusProvider',
                              );
                            },
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </RenderTable>
            </div>
          </Tab>
          <Tab eventKey={'display_on_portal'} title="Display on Portal">
            <div>
              <p className="help-text">
                Configure whether Claims status will be displayed on Portal.
              </p>
            </div>
            <div className="table-container">
              <RenderTable>
                {claimsListData.map((label, index) => {
                  return (
                    <tr key={label.InternalStatus}>
                      <td className="internal-status-cell">
                        {label.InternalStatus}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayOnPortalMember}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayOnPortalMember',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayOnPortalInsurer}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayOnPortalInsurer',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayOnPortalClient}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayOnPortalClient',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayOnPortalBroker}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayOnPortalBroker',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayOnPortalProvider}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayOnPortalProvider',
                              );
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </RenderTable>
            </div>
          </Tab>
          <Tab eventKey={'display_on_dashboard'} title="Display on Dashboard">
            <div>
              <p className="help-text">
                Configure whether Claims status will be displayed on Dashboard.
              </p>
            </div>
            <div className="table-container">
              <RenderTable onlyForMembers={true}>
                {claimsListData.map((label, index) => {
                  return (
                    <tr key={label.InternalStatus}>
                      <td className="internal-status-cell text-left">
                        {label.InternalStatus}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayOnDashboard}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayOnDashboard',
                              );
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </RenderTable>
            </div>
          </Tab>
          <Tab
            eventKey={'display_payment_information'}
            title="Display Payment Information"
          >
            <div>
              <p className="help-text">
                Configure whether payment information will be displayed.
              </p>
            </div>
            <div className="table-container">
              <RenderTable>
                {claimsListData.map((label, index) => {
                  return (
                    <tr key={label.InternalStatus}>
                      <td className="internal-status-cell">
                        {label.InternalStatus}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayPaymentInformationMember}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayPaymentInformationMember',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayPaymentInformationInsurer}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayPaymentInformationInsurer',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayPaymentInformationClient}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayPaymentInformationClient',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayPaymentInformationBroker}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayPaymentInformationBroker',
                              );
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center config-checkbox-container">
                          <Checkbox
                            isDisabled={!editMode}
                            checked={label.DisplayPaymentInformationProvider}
                            onChange={(e) => {
                              console.log('**********', e);
                              onValueChange(
                                e.target.checked,
                                index,
                                'DisplayPaymentInformationProvider',
                              );
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </RenderTable>
            </div>
          </Tab>
        </Tabs>
      </div>

      {/*buttons */}
      {editMode && (
        <div className="d-flex flex-wrap justify-content-end mt-5">
          <GenericButton
            className="mr-3"
            onClick={() => {
              setEditMode(false);
              //setValueChanged(false);
              window.scrollTo(0, 0);
              setClaimsListData([...claimsListDataOriginal]);
            }}
            buttonDisabled={!editMode}
            disable={!editMode}
            variant="link"
          >
            Cancel
          </GenericButton>
          <GenericButton
            className="ml-1"
            disable={!valuesChanged || !editMode}
            onClick={updateDataApiCallHandler}
            buttonDisabled={!valuesChanged || !editMode}
          >
            Save
          </GenericButton>
        </div>
      )}
      {/*buttons end here */}
    </div>
  );
};

export default ClaimsConfiguration;
